export {default} from './HealthProfile.connect';
